import styled, { css } from 'styled-components';

import { RowCentered } from 'pages/Login/style';
import { pxToRem } from 'utils/scss';

export const ForgotPasswordTitle = styled.div`
  padding-top:${pxToRem('70px')}
  color: ${props => props.theme.colors.white};
  display: flex;
  justify-content: center;
`;
export const ForgotPasswordText = styled.div`
  color: ${props => props.theme.colors.white};
  text-align: center;
  margin: ${pxToRem('25px')} -${pxToRem('56px')};
`;
export const ForgotButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: ${pxToRem('60px')} auto 0 auto;
  z-index: 10;
`;
export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: ${pxToRem('10px')} auto;
  ${props =>
    props.onPswChangeSuccess &&
    css`
      margin-top: ${pxToRem('50px')};
    `}
`;

export const InsertEmailTextWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${pxToRem('20px')};
`;
export const InsertEmailText = styled.div`
  color: ${props => props.theme.colors.white};

  margin: ${pxToRem('25px')} ${pxToRem('20px')};
  text-align: center;
`;
export const InvalidEmailText = styled.div`
  color: ${props => props.theme.colors.white};
  margin: ${pxToRem('0px')} ${pxToRem('20px')};
  text-align: center;
`;
export const ResendCode = styled.div`
  color: ${props => props.theme.colors.white};
  text-align: center;
  cursor: pointer;

  ${props =>
    props.isLoading &&
    css`
      opacity: 0.5;
      cursor: default;
    `}
`;

export const PasswordSuccessWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  z-index: 1;
`;

export const PasswordSuccessHeader = styled.div`
  font-family: OpenSans;
  font-size: ${pxToRem('24px')};
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: ${props => props.theme.colors.white}
  padding-bottom: ${pxToRem('15px')};
  margin: 0 -${pxToRem('32px')};
`;
export const SuccessIconWrapper = styled.span`
  padding-bottom: ${pxToRem('15px')};
  font-size: ${pxToRem('85px')};
  color: ${props => props.theme.colors.white};
`;
export const PasswordSuccessText = styled.div`
  font-family: OpenSans;
  font-size: ${pxToRem('14px')};
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.57;
  letter-spacing: normal;
  text-align: center;
  padding-bottom: ${pxToRem('15px')};
  color: ${props => props.theme.colors.white};
  margin: 0 -${pxToRem('10px')};
`;

export const ErrorWrapper = styled(RowCentered)`
  padding-top: ${pxToRem('16px')};
  padding-bottom: ${pxToRem('16px')};

  ${props =>
    props.createPassword &&
    css`
      padding-top: ${pxToRem('55px')};
      padding-bottom: ${pxToRem('0px')};
    `}
`;

export const IconClose = styled.div`
  position: fixed;
  top: ${pxToRem('40px')};
  right: ${pxToRem('40px')};
  color: ${props => props.theme.colors.black.one};
  font-size: ${pxToRem('32px')};
  cursor: pointer;
`;
export const SendOTPText = styled.div`
  text-align: center;
  color: #fff;
  font-size: ${pxToRem('12px')};
  display: flex;
  justify-content: center;
  gap: ${pxToRem('10px')};
  margin-top: ${pxToRem('10px')};
`;
export const SubmitWrapper = styled.div`
  padding-top: ${pxToRem('20px')};
  text-transform: uppercase;
  display: flex;
  gap: ${pxToRem('15px')};
  justify-content: center;
  z-index: 10;
`;

export const SpinnerContainer = styled.div`
  flex: 1 1 auto;
  width: 100%;
  height: 5rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;
